import { Box, Flex } from '@modusign/design-system';
import { MouseEventHandler, ReactNode } from 'react';

interface HeaderButtonProps {
  ariaLabel?: string;
  children: ReactNode;
  disabled?: boolean;
  tooltipMessage?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

function HeaderButton({
  ariaLabel,
  children,
  disabled,
  tooltipMessage,
  onClick,
}: HeaderButtonProps) {
  return (
    <Flex
      alignItems="center"
      aria-label={ariaLabel}
      as="button"
      borderRadius="4px"
      disabled={disabled}
      height="44px"
      justifyContent="center"
      position="relative"
      sx={{
        '&:hover': {
          backgroundColor: 'darkGray600',
          '&:disabled': {
            backgroundColor: 'unset',
          },
          '.HeaderButton__tool-tip': {
            display: 'block',
          },
        },
        '&:disabled': {
          opacity: 0.5,
        },
      }}
      type="button"
      width="44px"
      onClick={onClick}
    >
      {children}
      {tooltipMessage && (
        <Box
          backgroundColor="white"
          borderRadius="4px"
          className="HeaderButton__tool-tip"
          color="#2e3949"
          display="none"
          fontSize="sm"
          fontWeight="medium"
          left="50%"
          minWidth="50px"
          mt={4}
          position="absolute"
          px="9px"
          py={2}
          sx={{
            animationDuration: '0.6s',
            animationName: 'HeaderButton__tool-tip',
            transform: 'translateX(-50%)',
            '@keyframes HeaderButton__tool-tip': {
              '0%': {
                opacity: 0,
              },
              '50%': {
                opacity: 0,
              },
              '100%': {
                opacity: 1,
              },
            },
          }}
          textAlign="center"
          top="115%"
        >
          <Box
            borderColor="transparent transparent white"
            borderStyle="solid"
            borderWidth="0 8px 12px"
            display="block"
            height="0"
            left="50%"
            position="absolute"
            sx={{
              content: '""',
              transform: 'translateX(-50%)',
            }}
            top="-12px"
            width="0"
          />
          {tooltipMessage}
        </Box>
      )}
    </Flex>
  );
}

export default HeaderButton;
